import Calendar from "./calendar.vue";

let Plugin = {},
  vueInstance;

Plugin.install = function(Vue, opt) {
  opt.root.calendar = function() {
    // if (!vueInstance) {
    let el = document.createElement("div");
    document.querySelector("body").appendChild(el);

    let vueClass = Vue.extend(Calendar);

    vueInstance = new vueClass({
      el: el,
      router: opt.router,
    });
    // }

    vueInstance.wrapshow = true;
    return vueInstance.showPicker(...arguments);
  };
};

export default Plugin;
